import type { NavigationAdapter } from '@shared-core/navigation/adapter'
import type { NavKey, NavParams } from '@shared-core/navigation/routes'

let adapter: NavigationAdapter | null = null

// Платформа на старте (entry) регистрирует свой адаптер: installNavigation(MobileNavigationAdapter).
export function installNavigation(next: NavigationAdapter): void {
  adapter = next
}

export function getAdapter(): NavigationAdapter {
  if (!adapter) {
    throw new Error('[navigation] адаптер не установлен — вызови installNavigation(adapter) в entry платформы')
  }
  return adapter
}

// Если параметры маршрута допускают void — второй аргумент необязателен.
type Args<K extends NavKey> = undefined extends NavParams[K] ? [params?: NavParams[K]] : [params: NavParams[K]]

// Единый фасад навигации. Дёргается откуда угодно (в т.ч. из shared-логики/thunk-ов);
// делегирует в установленный платформенный адаптер.
export const navigation = {
  navigate<K extends NavKey>(key: K, ...args: Args<K>): void {
    getAdapter().navigate(key, args[0])
  },
  navigateFromSheet<K extends NavKey>(key: K, ...args: Args<K>): void {
    getAdapter().navigateFromSheet(key, args[0])
  },
  navigateDismissingSheets<K extends NavKey>(key: K, ...args: Args<K>): void {
    getAdapter().navigateDismissingSheets(key, args[0])
  },
  dismissSheetsBelowCurrent(): void {
    getAdapter().dismissSheetsBelowCurrent()
  },
  popTo<K extends NavKey>(key: K, ...args: Args<K>): void {
    getAdapter().popTo(key, args[0])
  },
  reset<K extends NavKey>(key: K, ...args: Args<K>): void {
    getAdapter().reset(key, args[0])
  },
  resetToHomeWithSheet<K extends NavKey>(key: K, ...args: Args<K>): void {
    getAdapter().resetToHomeWithSheet(key, args[0])
  },
  goBack(): void {
    getAdapter().goBack()
  },
  popToTop(): void {
    getAdapter().popToTop()
  },
  getCurrentRouteName(): string | undefined {
    return adapter?.getCurrentRouteName()
  },
}
